import { UserIdChannel } from '@remento/web-analytics-client/@types';
import { BrowserAnalytics } from '@remento/web-analytics-client/analytics.browser';

import { Payload, Router } from '../../router.js';

import { EmailFormSubmitEvent, EmailFormSubmitPayload } from './@types.js';

const HANDLER_ID = 'form';

export function registerEmailFormHandler(router: Router, analytics: BrowserAnalytics) {
  const logger = router.logger.extend('form-handler');
  router.registerHandler(HANDLER_ID, async (event: string, payload: Payload<unknown>) => {
    switch (event) {
      case EmailFormSubmitEvent: {
        const eventPayload = payload as Payload<EmailFormSubmitPayload>;
        const formId = `${analytics.source}.${payload.properties.pageId}.${eventPayload.data.formType}-form`;
        logger.debug('FORM_EMAIL_EVENT', () => ({ type: event, payload }));

        const identities: Array<UserIdChannel> = [];
        if (eventPayload.data.phone != null) {
          identities.push({ type: 'phone', value: eventPayload.data.phone });
        }
        if (eventPayload.data.email != null) {
          identities.push({ type: 'email', value: eventPayload.data.email });
        }
        if (identities.length == 0) {
          logger.warn('NO_IDENTIFIER', () => ({ type: event, payload }));
        }
        if (identities.length > 0 && eventPayload.data.formType !== 'referral') {
          await analytics.identify(identities, formId);
          await analytics.track('website.form', {
            form: eventPayload.data.formType,
            formId: formId,
            ...eventPayload.data,
            ...eventPayload.properties,
          });
        } else if (eventPayload.data.formType === 'referral') {
          // In case this is a referral, the provided identifiers are for the referred user, not the current user.
          // We avoid identifying using the provided identifiers and we enable the segment backend to make sure
          // the website.form event get processed by Segment.
          await analytics.enableSegment();
          await analytics.track('refer', {
            form: eventPayload.data.formType,
            formId: formId,
            ...eventPayload.data,
            ...eventPayload.properties,
          });
        }
        return true;
      }
    }
    return false;
  });
}
